import * as React from 'react';

function SvgShareAndroid(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M16.82 3a3 3 0 11-1.53 5.58L9 12.01l6.33 3.45a3 3 0 11-1.26 1.59l-5.69-3.1a3 3 0 11-.13-3.8L13.99 7a3 3 0 012.83-4z" />
    </svg>
  );
}

export default SvgShareAndroid;
